import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslationModule } from '../translation.module';
import { WidgetSubAppTransitionModule } from 'src/app/micro-frontends/widget-sub-app-transition/widget-sub-app-transition.module';
import { ModernPreloadMFRoutingModule } from './modern-preload-mf-routing.module';
import { PageModernPreloadComponent } from 'src/app/components/pages/page-modern-preload/page-modern-preload.component';
import { PageLayoutModule } from 'src/app/components/page-layout/page-layout.module';

@NgModule({
	declarations: [PageModernPreloadComponent],
	imports: [
		CommonModule,
		ModernPreloadMFRoutingModule,
		TranslationModule.forChild(),
		WidgetSubAppTransitionModule,
		PageLayoutModule,
	],
	exports: [PageLayoutModule],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ModernPreloadModuleMF {}
